export const CHANGE_WARNING_MODAL_STATE = 'CHANGE_WARNING_MODAL_STATE';
export const CHANGE_SUCCESS_MODAL_STATE = 'CHANGE_SUCCESS_MODAL_STATE';
export const CHANGE_DELETE_MODAL_STATE = 'CHANGE_DELETE_MODAL_STATE';
export const CHANGE_DISSCONNECT_MODAL_STATE = 'CHANGE_DISSCONNECT_MODAL_STATE';
export const CHANGE_ADD_ACCOUNT_MODAL_STATE = 'CHANGE_ADD_ACCOUNT_MODAL_STATE';
export const TEST_STARTED = 'TEST_STARTED';
export const TEST_SUCCESS = 'TEST_SUCCESS';
export const TEST_FAILED = 'TEST_FAILED';
export const LOGIN_GOOGLE_FETCH = 'LOGIN_GOOGLE_FETCH';
export const LOGIN_GOOGLE_SUCCESS = 'LOGIN_GOOGLE_SUCCESS';
export const LOGIN_GOOGLE_FAILED = 'LOGIN_GOOGLE_FAILED';
export const GET_USER_DATA_FETCHED = 'GET_USER_DATA_FETCHED';
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_FAILED = 'GET_USER_DATA_FAILED';
export const GET_ACTIVITY_DATA_FETCHED = 'GET_ACTIVITY_DATA_FETCHED';
export const GET_ACTIVITY_DATA_SUCCESS = 'GET_ACTIVITY_DATA_SUCCESS';
export const GET_ACTIVITY_DATA_FAILED = 'GET_ACTIVITY_DATA_FAILED';
export const GET_GMAIL_LOGIN_LINK_FETCHED = 'GET_GMAIL_LOGIN_LINK_FETCHED';
export const GET_GMAIL_LOGIN_LINK_SUCCESS = 'GET_GMAIL_LOGIN_LINK_SUCCESS';
export const GET_GMAIL_LOGIN_LINK_FAILED = 'GET_GMAIL_LOGIN_LINK_FAILED';
export const GET_SLACK_LOGIN_LINK_FETCHED = 'GET_SLACK_LOGIN_LINK_FETCHED';
export const GET_SLACK_LOGIN_LINK_SUCCESS = 'GET_SLACK_LOGIN_LINK_SUCCESS';
export const GET_SLACK_LOGIN_LINK_FAILED = 'GET_SLACK_LOGIN_LINK_FAILED';
export const GET_CONNECTION_LINKS_SUCCESS = 'GET_CONNECTION_LINKS_SUCCESS';
export const GET_CONNECTION_LINKS_ERROR = 'GET_CONNECTION_LINKS_ERROR';
export const GET_SUBSCRIPTIONS_FETCHED = 'GET_SUBSCRIPTIONS_FETCHED';
export const GET_SUBSCRIPTIONS_SUCCESS = 'GET_SUBSCRIPTIONS_SUCCESS';
export const GET_SUBSCRIPTIONS_FAILED = 'GET_SUBSCRIPTIONS_FAILED';
export const SEARCH_FIELD_CHANGED = 'SEARCH_FIELD_CHANGED';
export const SEARCH_DATA_FETCHED = 'SEARCH_DATA_FETCHED';
export const SEARCH_DATA_SUCCESS = 'SEARCH_DATA_SUCCESS';
export const SEARCH_DATA_FAILED = 'SEARCH_DATA_FAILED';
export const GET_BOOKMARKS_FETCHED = 'GET_BOOKMARKS_FETCHED';
export const GET_BOOKMARKS_SUCCESS = 'GET_BOOKMARKS_SUCCESS';
export const GET_BOOKMARKS_FAILED = 'GET_BOOKMARKS_FAILED';
export const POST_BOOKMARK_FETCHED = 'POST_BOOKMARK_FETCHED';
export const POST_BOOKMARK_SUCCESS = 'POST_BOOKMARK_SUCCESS';
export const POST_BOOKMARK_FAILED = 'POST_BOOKMARK_FAILED';
export const DELETE_BOOKMARK_FETCHED = 'DELETE_BOOKMARK_FETCHED';
export const DELETE_BOOKMARK_SUCCESS = 'DELETE_BOOKMARK_SUCCESS';
export const DELETE_BOOKMARK_FAILED = 'DELETE_BOOKMARK_FAILED';
export const FEEDBACK_DATA_FETCHED = 'FEEDBACK_DATA_FETCHED';
export const FEEDBACK_DATA_SUCCESS = 'FEEDBACK_DATA_SUCCESS';
export const FEEDBACK_DATA_FAILED = 'FEEDBACK_DATA_FAILED';
export const PERMALINK_DATA_FETCHED = 'PERMALINK_DATA_FETCHED';
export const PERMALINK_DATA_SUCCESS = 'PERMALINK_DATA_SUCCESS';
export const PERMALINK_DATA_FAILED = 'PERMALINK_DATA_FAILED';
export const DELETE_USER_FETCHED = 'DELETE_USER_FETCHED';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILED = 'DELETE_USER_FAILED';
export const DISSCONNECT_ACCOUNT_FETCHED = 'DISSCONNECT_ACCOUNT_FETCHED';
export const DISSCONNECT_ACCOUNT_SUCCESS = 'DISSCONNECT_ACCOUNT_SUCCESS';
export const DISSCONNECT_ACCOUNT_FAILED = 'DISSCONNECT_ACCOUNT_FAILED';
export const SIGN_OUT = 'SIGN_OUT';
export const DELETE_ACTIVITY_FETCHED = 'DELETE_ACTIVITY_FETCHED';
export const DELETE_ACTIVITY_SUCCESS = 'DELETE_ACTIVITY_SUCCESS';
export const DELETE_ACTIVITY_FAILED = 'DELETE_ACTIVITY_FAILED';
export const CHANGE_FEEDBACK_MODAL_STATE = 'CHANGE_FEEDBACK_MODAL_STATE';
export const CHANGE_SAY_THANKS_MODAL_STATE = 'CHANGE_SAY_THANKS_MODAL_STATE';
export const DELETE_BOOKMARK_LOCALY = 'DELETE_BOOKMARK_LOCALY';